<main class="admin-shell">
  <section class="admin-container">
    <header class="admin-header">
      <div>
        <p class="eyebrow">{{ 'common.ssoBrand' | translate }}</p>
        <h1>{{ 'adminUsers.title' | translate }}</h1>
        <p class="subtitle">{{ 'adminUsers.subtitle' | translate }}</p>
      </div>
      <a nz-button routerLink="/main">{{ 'common.backToModules' | translate }}</a>
    </header>

    @if (errorMessage) {
      <nz-alert nzType="error" [nzMessage]="errorMessage" nzShowIcon></nz-alert>
    }

    <nz-card class="users-card">
      <form class="filters" (submit)="$event.preventDefault(); applyFilters()">
        <label>
          <span>{{ 'authLogs.loginFilter' | translate }}</span>
          <input nz-input [formControl]="username" [placeholder]="'authLogs.loginPlaceholder' | translate">
        </label>

        <label>
          <span>Email</span>
          <input nz-input type="email" [formControl]="email" placeholder="user@example.com">
        </label>

        <div class="filter-actions">
          <button nz-button nzType="primary" type="submit" [nzLoading]="isLoading">{{ 'common.find' | translate }}</button>
          <button nz-button type="button" (click)="resetFilters()">{{ 'common.resetFilters' | translate }}</button>
        </div>
      </form>

      <nz-table
        [nzData]="users"
        [nzLoading]="isLoading"
        [nzShowPagination]="false"
        [nzNoResult]="'adminUsers.empty' | translate"
        nzSize="middle"
      >
        <thead>
        <tr>
          <th>{{ 'adminUsers.colLogin' | translate }}</th>
          <th>{{ 'adminUsers.colLastLogin' | translate }}</th>
          <th>{{ 'adminUsers.colStatus' | translate }}</th>
          <th>{{ 'adminUsers.colLockReason' | translate }}</th>
          <th>{{ 'adminUsers.colRoles' | translate }}</th>
          <th class="actions-column">{{ 'common.actions' | translate }}</th>
        </tr>
        </thead>
        <tbody>
          @for (user of users; track user.id) {
            <tr>
              <td class="username">{{ user.username }}</td>
              <td>{{ user.lastActivityDate || '—' }}</td>
              <td>
                <nz-tag [nzColor]="isLocked(user) ? 'red' : 'green'">
                  {{ (isLocked(user) ? 'adminUsers.blocked' : 'adminUsers.active') | translate }}
                </nz-tag>
              </td>
              <td>{{ user.lockedReason || '—' }}</td>
              <td>
                @for (role of user.roles; track role) {
                  <nz-tag>{{ roleLabel(role) | translate }}</nz-tag>
                } @empty {
                  —
                }
              </td>
              <td class="actions-column">
                <button
                  nz-button
                  nzType="text"
                  nzSize="small"
                  nz-dropdown
                  nzTrigger="click"
                  [nzDropdownMenu]="rowActions"
                  [attr.aria-label]="'common.actions' | translate"
                >
                  <nz-icon nzType="more"></nz-icon>
                </button>

                <nz-dropdown-menu #rowActions="nzDropdownMenu">
                  <ul nz-menu>
                    <li nz-menu-item (click)="editEmail(user)">{{ 'adminUsers.editEmail' | translate }}</li>
                    @if (isSuperAdmin()) {
                      <li nz-menu-item (click)="editRoles(user)">{{ 'adminUsers.editRoles' | translate }}</li>
                    }
                    @if (canSetPsd(user)) {
                      <li nz-menu-item (click)="editPsd(user)">{{ 'adminUsers.setPsd' | translate }}</li>
                    }
                    @if (canBlock(user)) {
                      <li nz-menu-item nzDanger (click)="block(user)">{{ 'adminUsers.block' | translate }}</li>
                    }
                    <li nz-menu-item [nzDisabled]="!isLocked(user)" (click)="unblock(user)">{{ 'adminUsers.unblock' | translate }}</li>
                  </ul>
                </nz-dropdown-menu>
              </td>
            </tr>
          }
        </tbody>
      </nz-table>

      @if (totalElements > pageSize) {
        <div class="pagination">
          <span>{{ 'common.total' | translate }} {{ totalElements }}</span>
          <nz-pagination
            [nzPageIndex]="page"
            [nzPageSize]="pageSize"
            [nzTotal]="totalElements"
            [nzShowSizeChanger]="false"
            (nzPageIndexChange)="changePage($event)"
          ></nz-pagination>
        </div>
      }
    </nz-card>
  </section>
</main>
